import { useSelector } from 'react-redux';
import { useRouteParams } from '@/context/routeParamsContext';
import {
  getCardArtUrl,
  splitAccessAndGuestPolicyHeader,
} from '@/helpers/utils';
import { cardArtMapping } from '@/constants/productMapping';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { getLocaleData } from '@/selectors/localeSelectors';
import {
  usePoliciesByLoungeId,
  useLoungeAccessListMatchedWithLocaleProviders,
  useIsWaitListEnabledLounge,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useSelectedProductFromUserWallet } from '@/hooks/memberHooks';
import useAutoOpenCardPickerModal from '@/hooks/useAutoOpenCardPickerModal';

const useLoungeDetailsSidebarData = () => {
  useAutoOpenCardPickerModal();

  const { product, loungeId } = useRouteParams();
  const { accessLevel, guestPolicy } =
    useLoungeAccessListMatchedWithLocaleProviders(loungeId);
  const {
    guestPolicyLabel: loungeSpecificGuestPolicyLabel,
    accessPolicyLabel: loungeSpecificAccessPolicyLabel,
  } = usePoliciesByLoungeId(loungeId);
  const {
    lounges: { accessPanel, agTab },
    selectCard,
  } = useCommonContent();
  const isWaitListAvailableAtLounge = useIsWaitListEnabledLounge(loungeId);
  const { locale } = useSelector(getLocaleData);
  const baseOneCmsImgUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const selectedWalletProduct =
    useSelectedProductFromUserWallet(product, locale) || {};
  const defaultCardImageUrl = getCardArtUrl({
    baseOneCmsImgUrl,
    product: cardArtMapping[product],
    locale,
    isMedium: true,
  });
  const [accessPolicyHeaderText, guestPolicyHeaderText] =
    splitAccessAndGuestPolicyHeader(agTab);

  return {
    accessPolicyHeading:
      loungeSpecificAccessPolicyLabel || accessPolicyHeaderText,
    baseOneCmsImgUrl,
    cardImageSrc: selectedWalletProduct.cardArtUrl || defaultCardImageUrl,
    cardSwitchLinkText: selectCard?.link,
    guestPolicyHeading: loungeSpecificGuestPolicyLabel || guestPolicyHeaderText,
    hasAccessPolicy: Boolean(accessLevel),
    hasGuestPolicy: Boolean(guestPolicy),
    hasWalletProduct: Object.keys(selectedWalletProduct).length > 0,
    inlineCardMessage: selectCard?.inlineMessage,
    isWaitListAvailableAtLounge,
    locale,
    loggedInCardPill: selectCard?.cardPill_loggedIn,
    product,
    termsLinkText: accessPanel?.link,
  };
};

export default useLoungeDetailsSidebarData;
